import { combineEpics } from 'redux-observable';
import adminItemsEpicsRoot from './adminItems';

export const adminItemsEpic = combineEpics(adminItemsEpicsRoot);
